import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom'; 
import { toast } from 'react-toastify';
import Loader from '../components/Loader';

const TaggingDetails = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedTag, setSelectedTag] = useState(null);
    const [status, setStatus] = useState(null);
    const [reason, setReason] = useState('');
    const { tagId } = useParams();
    const logoImgRefs = useRef([]);
    const coverImgRefs = useRef([]);
    const loadedCount = useRef(0);

    const updateHeights = () => {
        logoImgRefs.current.forEach((logo, index) => {
            const cover = coverImgRefs.current[index];
            if (logo && cover) {
                const height = logo.offsetHeight;
                cover.style.height = `${height}px`;
                console.log(height);
            }
        });
    };

    useEffect(() => {
        const fetchListings = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.taggingRequest}`,
                    data: formData
                });
            
                if (response.data.items && Array.isArray(response.data.items)) {
                    const filteredListings = response.data.items.filter(listing => String(listing.id_tag_id) === String(tagId));
                    setListings(filteredListings);
                    setLoading(false);
                } else {
                    setError('An error occurred while fetching data.');
                }
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchListings();
    }, []);

    const handleImageLoad = (index) => {
        loadedCount.current += 1;
        if (loadedCount.current === listings.length * 2) {
            updateHeights();
        }
    };

    useEffect(() => {
        if (listings.length > 0) {
            window.addEventListener('resize', updateHeights);
            return () => {
                window.removeEventListener('resize', updateHeights);
            };
        }
    }, [listings]);

    const handleActionClick = (listing, action) => {
        setSelectedTag(listing);
        setStatus(action);
        setReason('');
        setShowPopup(true);
    };

    const handleSubmit = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);
        formData.append('tag_id', selectedTag.id_tag_id);
        formData.append('status', status);
        if (status === 'reject' && reason.trim()) {
            formData.append('reason', reason);
        }

        try {
            const response = await axios({
                method: 'post',
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                url: `${params.baseURL}${params.endpoints.updateStatus}`,
                data: formData
            });

            if (response.data.status === 'ok') {
                setShowPopup(false);
                toast.success('Status Updated Successfully!');
                window.location.reload();
                //setListings(listings.filter(item => String(item.id_tag_id) === String(tagId)));
            } else {
                setError('An error occurred while fetching data.');
            }
            
        } catch (error) {
            console.error('Error updating status:', error);
        }
    };

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Tagging Request</title>
                <meta name="description" content="" />
            </Helmet>
            
            <div className='row'>
                <div className='col-md-6 m-auto'>
                    <div className='yl-header p-0'>
                        <div>
                            <img src={'/assets/img/banners/tag_request_banner_6.png'} className='img-fluid w-100' />
                        </div>
                    </div>
                </div>
            </div>

            {listings.length > 0 ? (
                <div className='row'>
                    {listings.map((listing, index) => (
                        <div className='col-md-6 lb mb-3 m-auto' key={listing.stay_listing_id}>
                            <a href={'javascript:void(0);'}>
                                <div className='acc-box' style={{marginBottom:'10px'}}>
                                    <div className="apimgcibox">
                                        <div className='image-wrapper lcibox'>
                                            <div className='ac-cover-image'>
                                                <img
                                                    ref={(el) => (coverImgRefs.current[index] = el)}
                                                    className="ciso ap-ciso"
                                                    src={listing.cover_photo ? listing.cover_photo : '/assets/img/default_listing.jpg'}
                                                    alt={listing.listing_title ? listing.listing_title : 'Untitled Listing'}
                                                    onLoad={() => handleImageLoad(index)}
                                                />
                                            </div>
                                        </div>
                                        <div className="logo-wrapper">
                                            <img
                                                ref={(el) => (logoImgRefs.current[index] = el)}
                                                src={listing.category_image}
                                                alt=''
                                                className='cist'
                                                onLoad={() => handleImageLoad(index)}
                                            />
                                        </div>
                                    </div>
                                    <div className='pltxt-box'>
                                        <div className='cat-pointer mb-0'>
                                            <img src={listing.property_title_icon_image}  alt="Profile" className="pointer-icon" />
                                            <div className='wspl-ta-section w-100'>
                                                <span className='wspl-title-box'>{listing.listing_title || 'Unknown Title'}</span>
                                                <span className='wspl-add-box'>{listing.property_address}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <div className='iddata-box'>
                                        <img src={listing.designed_by.pic || '/assets/img/icons/legal_name_icon.svg'} className='img-fluid' style={{borderRadius:'50%'}} alt='' />
                                        <span className='iddata-line'></span>
                                        <div style={{textAlign:'left'}}>
                                            <span className='d-block'>{listing.designed_by.name}</span>
                                            <span>Portfolio</span>
                                        </div>
                                    </div>
                                    {listing.id_tag_message && (
                                    <div className='iddatam-box'>
                                        <span>{listing.id_tag_message}</span>
                                    </div>
                                    )}
                                </div>
                                <div className='tdvbtn-box' style={{paddingLeft:'0',paddingRight:'0'}}>
                                    {listing.id_tag_status === 3 && (
                                        <>
                                            <button className='acc-btn-txt btn-accept' onClick={() => handleActionClick(listing, 1)}>Accept</button>
                                            <button className='acc-btn-txt btn-reject' onClick={() => handleActionClick(listing, 2)}>Reject</button>
                                        </>
                                    )}
                                    {listing.id_tag_status === 1 && (
                                        <button className='acc-btn-txt btn btn-success' disabled>Accepted</button>
                                    )}
                                    {listing.id_tag_status === 2 && (
                                        <button className='acc-btn-txt btn btn-danger' disabled>Rejected</button>
                                    )}
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            ) : (
                <p>No listings found</p>
            )}

            {showPopup && (
                <div className='confirmation-popup-overlay'>
                    <div className='confirmation-popup' style={{width:'600px'}}>
                        <div className='euc-box'>
                            <div className='popup-body' style={{position:'relative'}}>
                                <img src={'/assets/img/banners/unlock_popup_banner_1.webp'} className='img-fluid' alt='' />
                                <div className='euc-close' onClick={() => setShowPopup(false)}>
                                    <img src={'/assets/img/icons/popup_close.png'} className='img-fluid' alt='' />
                                </div>
                            </div>
                            <div className='popup-subcnt' style={{background:'#fff', padding:'20px 0'}}>
                                <div className='dbcarrb'>
                                    <h4 className='text-uppercase m-0'>{status === 1 ? 'Confirm Acceptance' : 'Reject Request'}</h4>
                                </div>
                                {status === 2 && (
                                    <textarea
                                        placeholder='Enter reason for rejection'
                                        value={reason}
                                        className='form-control'
                                        onChange={(e) => setReason(e.target.value)}
                                        style={{marginTop:'20px'}}
                                    />
                                )}

                                <div className='tdvbtn-box' style={{padding:'20px 0'}}>
                                    <button className='acc-btn-txt btn btn-black' onClick={handleSubmit} style={{borderRadius:'2px !important'}}>Go Ahead</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default TaggingDetails;
